import Dropdown from './dropdown_controller'

export default class extends Dropdown {
  static targets = ['body', 'arrow', 'selected', 'placeholder', 'list' ]

  connect() {
    super.connect()
    this.element[this.identifier] = this
    this.emptyClass = 'empty'
    this.activeClass = 'active'
    this.setActive(this.getElement(this.data.get('selected')))
  }

  select(e) {
    this.clearActive()
    this.setActive(e.target)

    this.element.dispatchEvent(new CustomEvent('changed', { detail: { value: this.selected } }))
    this.closeImmediately()
  }

  reset() {
    this.clearActive()
    this.setActive(this.placeholderTarget)
  }

  clearActive() {
    const active = this.listTarget.querySelector('.filter-item.active')
    if (active) { active.classList.remove(this.activeClass) }
  }

  setActive(el) {
    el.classList.add(this.activeClass)
    this.selectedTarget.textContent = el.textContent
    this.selected = el.dataset.id || ''

    if (el == this.placeholderTarget) {
      this.element.classList.add(this.emptyClass)
    } else {
      this.element.classList.remove(this.emptyClass)
    }
  }

  update(items) {
    this.setActive(this.placeholderTarget)

    while(this.listTarget.lastChild != this.placeholderTarget) {
      this.listTarget.lastChild.remove()
    };

    let listHTML = ''
    items.forEach(element => {
      listHTML += `<li class="filter-item" data-id="${element[0]}">${element[1]}</li>`
    })
    this.listTarget.innerHTML += listHTML
  }

  getElement(id) {
    return this.listTarget.querySelector(`[data-id="${id}"]`) || this.placeholderTarget
  }
}
